module.exports = __webpack_public_path__ + "components/trial/static/thumbs-up-c784c5e08857f0545be8670380761141.svg";